"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileDropUpload = FileDropUpload;
exports.FileDropUploadControlled = FileDropUploadControlled;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _reactClassset = _interopRequireDefault(require("react-classset"));
var _reactDropzone = require("react-dropzone");
var _FormHint = _interopRequireDefault(require("../../structure/FormHint"));
var _excluded = ["showError", "noButton", "name", "className", "multiple", "disabled", "errors", "onChange", "onDrop", "buttonText", "children", "warning", "info"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * FileDropUpload
 * Nimmt Dateien via Drag&Drop oder File Dialog entgegen.
 *
 * @param props {Object} Properties des Element
 * @param props.onDrop {Function} Eventlistener der onChange und onDrop feuert.
 * @returns {*}
 * @constructor
 */
function FileDropUpload(props) {
  var showError = props.showError,
    noButton = props.noButton,
    name = props.name,
    className = props.className,
    multiple = props.multiple,
    disabled = props.disabled,
    errors = props.errors,
    onChange = props.onChange,
    onDrop = props.onDrop,
    buttonText = props.buttonText,
    children = props.children,
    warning = props.warning,
    info = props.info,
    dropzoneOptions = _objectWithoutProperties(props, _excluded);
  var _useDropzone = (0, _reactDropzone.useDropzone)(_objectSpread({
      multiple: multiple,
      disabled: disabled,
      onDrop: onDrop
    }, dropzoneOptions)),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    open = _useDropzone.open,
    isDragActive = _useDropzone.isDragActive,
    isDragAccept = _useDropzone.isDragAccept,
    isDragReject = _useDropzone.isDragReject,
    isFocused = _useDropzone.isFocused,
    isFileDialogActive = _useDropzone.isFileDialogActive;
  var hasErrors = showError && errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _reactClassset.default)(_defineProperty({
      'file-drop-upload': true,
      'disabled': disabled,
      'drag-active': isDragActive,
      'drag-accept': isDragAccept,
      'drag-reject': isDragReject,
      'focused': isFocused,
      'file-dialog-active': isFileDialogActive
    }, className, !!className))
  }, /*#__PURE__*/_react.default.createElement("div", getRootProps({
    className: 'file-drop-upload__dropzone'
  }), /*#__PURE__*/_react.default.createElement("input", _extends({
    name: name,
    onChange: onChange
  }, getInputProps())), /*#__PURE__*/_react.default.createElement("div", {
    className: "file-drop-upload__content"
  }, children), !noButton ? /*#__PURE__*/_react.default.createElement("button", {
    className: "file-drop-upload__button",
    type: "button",
    onClick: open
  }, buttonText) : null), /*#__PURE__*/_react.default.createElement(_FormHint.default, {
    error: errorMessage,
    warning: warning,
    info: info
  }));
}
function FileDropUploadControlled(props) {
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, _extends({
    defaultValue: ""
  }, props, {
    render: function render(_ref) {
      var _ref$field = _ref.field,
        onChange = _ref$field.onChange,
        onBlur = _ref$field.onBlur;
      return /*#__PURE__*/_react.default.createElement(FileDropUpload, _extends({}, props, {
        noClick: true,
        showError: true,
        onDrop: onChange,
        onBlur: onBlur
      }));
    }
  }));
}
var fileDropUploadPropTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  className: _propTypes.default.string,
  multiple: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  showError: _propTypes.default.bool,
  noButton: _propTypes.default.bool,
  errors: _propTypes.default.objectOf(_propTypes.default.shape({
    message: _propTypes.default.string,
    type: _propTypes.default.string
  })),
  warning: _propTypes.default.string,
  info: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
var fileDropUploadDefaultProps = {
  id: '',
  name: '',
  value: '',
  className: '',
  multiple: true,
  disabled: false,
  showError: false,
  noButton: false,
  errors: {},
  warning: null,
  info: null,
  buttonText: 'Datei auswählen',
  children: /*#__PURE__*/_react.default.createElement("p", null, "Dateien hierher ziehen oder")
};
FileDropUploadControlled.propTypes = _objectSpread(_objectSpread({}, fileDropUploadPropTypes), {}, {
  control: _propTypes.default.object.isRequired,
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired
});
FileDropUploadControlled.defaultProps = fileDropUploadDefaultProps;
FileDropUpload.propTypes = fileDropUploadPropTypes;
FileDropUpload.defaultProps = fileDropUploadDefaultProps;